import angular from 'angular';

(function() {
    'use strict';

    angular.module('app').component('watchgo', {
        template: require('./watchgo.html'),
        controller: WatchGoCtrl,
        controllerAs: 'vm'
    });

    WatchGoCtrl.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        '$filter',
        '$cookies',
        'ModalService',
        'QueryService',
        'logger'
    ];

    function WatchGoCtrl(
        $scope,
        $state,
        $stateParams,
        $filter,
        $cookies,
        ModalService,
        QueryService,
        logger
    ) {
    }
})();



// WEBPACK FOOTER //
// ./src/app/components/watchgo/watchgo.component.js